import React from 'react'
import ProcessorModal from '.'
import { useSelector } from 'react-redux'
import { selectIncompletedFields, selectMarkedNaFields } from '../slices/formInstanceSlice'

export default function BeforeSigningModal({
  open = false,
  onClose = () => {},
  onEdit = () => {},
  onSubmit = () => {},
}) {
  const numberIncompletedFields = useSelector(selectIncompletedFields).length
  const numberMarkedNaFields = useSelector(selectMarkedNaFields).length

  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6 }}>
        <div className="dome-d-flex dome-flex-column dome-gap24">
          <div>
            <span className="dome-h2 dome-color-dark-green">before signing</span>
          </div>
          <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap12">
            <span className="dome-p1 dome-color-darkest-grey">Some fields may still need your attention: </span>
            <div className="dome-d-flex dome-gap24">
              <div className="dome-d-flex dome-flex-column">
                <span className="dome-h4 dome-color-dark-grey">{numberIncompletedFields}</span>
                <span className="dome-p3 dome-color-med-grey">missing fields</span>
              </div>
              <div className="dome-d-flex dome-flex-column">
                <span className="dome-h4 dome-color-dark-grey">0</span>
                <span className="dome-p3 dome-color-med-grey">expired fields</span>
              </div>
              <div className="dome-d-flex dome-flex-column">
                <span className="dome-h4 dome-color-dark-grey">{numberMarkedNaFields}</span>
                <span className="dome-p3 dome-color-med-grey">marked n/a</span>
              </div>
            </div>
          </div>
          <div className="dome-d-flex dome-justify-between">
            <button
              type="button"
              onClick={onClose}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-cancel dome-link-chevron-left"
            >
              sign later
            </button>
            <div className="dome-d-flex dome-gap6">
              <button type="button" onClick={onEdit} className="dome-btn dome-btn-base dome-btn-grey-stroke">
                edit form
              </button>
              <button type="button" onClick={onClose} className="dome-btn dome-btn-base dome-btn-dark-green">
                I acknowledge
              </button>
            </div>
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
